module.exports = __webpack_public_path__ + "static/media/lets_start.1c2ab9e9.svg";